function BluePlusIcon() {
	return (
		<svg
			width="41"
			height="40"
			viewBox="0 0 41 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="0.5"
				width="40"
				height="40"
				rx="20"
				fill="#2E7FDB"
				fillOpacity="0.1"
			/>
			<rect
				x="1"
				y="0.5"
				width="39"
				height="39"
				rx="19.5"
				stroke="#2E7FDB"
				strokeOpacity="0.2"
			/>
			<path
				d="M27.3569 19.8618H13.6426"
				stroke="#2E48DB"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20.4912 13.1431V26.9033"
				stroke="#2E48DB"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export default BluePlusIcon;
